import {useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import AtomTag, {atomTagColors, atomTagDesigns, atomTagSizes} from '@s-ui/react-atom-tag'
import {useSuiContext} from '@s-ui/react-context'
import MoleculeTextareaField, {MoleculeTextareaSizes} from '@s-ui/react-molecule-textarea-field'
import PrimitiveTypography, {
  primitiveTypographyDesign,
  primitiveTypographyFontSize,
  primitiveTypographyLineHeight
} from '@s-ui/react-primitive-typography'

const BASE_CLASS = 'mt-NetFeedback'
const MAX_CHARS_COMMENTS_FIELD = 1000

const NetFeedback = ({onSuccess, onFinish}) => {
  const {i18n, domain} = useSuiContext()
  const config = domain.get('config')
  const {FEEDBACK_REVIEW_TAGS} = config.get('COMMON').AI_ASSISTANT

  const [selectedTags, setSelectedTags] = useState([])
  const [comments, setComments] = useState('')

  const onClickTag = (e, id) => {
    e.preventDefault()
    if (selectedTags.includes(id)) {
      setSelectedTags(selectedTags.filter(tagId => tagId !== id))
    } else {
      setSelectedTags([...selectedTags, id])
    }
  }

  const onSubmit = e => {
    e.preventDefault()
    onSuccess(comments, selectedTags)
  }

  return (
    <form className={BASE_CLASS} onSubmit={onSubmit}>
      <PrimitiveTypography
        design={primitiveTypographyDesign.HEADLINE_1}
        lineHeight={primitiveTypographyLineHeight.XL}
        fontSize={primitiveTypographyFontSize.XXL}
      >
        {i18n.t('NET.FEEDBACK.TITLE')}
      </PrimitiveTypography>

      <div className={`${BASE_CLASS}-tags`}>
        {Object.values(FEEDBACK_REVIEW_TAGS).map(({id, label}) => (
          <AtomTag
            key={id}
            label={i18n.t(label)}
            size={atomTagSizes.MEDIUM}
            design={atomTagDesigns.OUTLINE}
            color={atomTagColors.PRIMARY}
            onClick={e => onClickTag(e, id)}
            pressed={selectedTags.includes(id)}
          />
        ))}
      </div>

      <MoleculeTextareaField
        id="feedback-review"
        value={comments}
        onChange={(event, {value}) => setComments(value)}
        maxChars={MAX_CHARS_COMMENTS_FIELD}
        textCharacters={i18n.t('COMMON.PLURALS.CHARACTER', MAX_CHARS_COMMENTS_FIELD).toLowerCase()}
        size={MoleculeTextareaSizes.LONG}
        nodeLabel={
          <>
            <span>{i18n.t('NET.FEEDBACK.COMMENTS_LABEL')}</span>
            <span className={`${BASE_CLASS}-labelOptional`}>({i18n.t('COMMON.OPTIONAL')})</span>
          </>
        }
      />

      <div className={`${BASE_CLASS}-footer`}>
        <AtomButton isFitted isSubmit shape={atomButtonShapes.CIRCULAR} size={atomButtonSizes.LARGE}>
          {i18n.t('NET.INPUT_SEND_MESSAGE')}
        </AtomButton>
        <AtomButton
          isFitted
          onClick={onFinish}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.LARGE}
          design={atomButtonDesigns.FLAT}
        >
          {i18n.t('COMMON.CANCEL')}
        </AtomButton>
      </div>
    </form>
  )
}

NetFeedback.displayName = 'NetFeedback'
NetFeedback.propTypes = {
  onFinish: PropTypes.func,
  onSuccess: PropTypes.func
}

export default NetFeedback
